import Element from '../utils/element';

export default function () {

	return Element('selected-filtres');

};